const emptyTranslation = () => ({
    title: '',
    features: '',
    badge: '',
});
export function createLandingTariffCardDraft(card) {
    if (!card) {
        return {
            isActive: false,
            sortOrder: '0',
            deviceNumber: '',
            locations: [],
            translations: { en: emptyTranslation() },
        };
    }
    const translations = { en: emptyTranslation() };
    for (const locale of ['en', 'ru', 'hy', 'tr']) {
        const value = card.translations[locale];
        if (!value)
            continue;
        translations[locale] = {
            title: value.title,
            features: value.features.join('\n'),
            badge: value.badge ?? '',
        };
    }
    return {
        isActive: card.is_active,
        sortOrder: String(card.sort_order),
        deviceNumber: String(card.device_number),
        locations: card.locations.map((selection) => ({
            location_id: selection.location_id,
            option_ids: [...selection.option_ids],
        })),
        translations,
    };
}
function normalizedSelections(selections) {
    return selections.map((selection) => ({
        location_id: selection.location_id,
        option_ids: [...new Set(selection.option_ids)],
    }));
}
export function setLocationSelected(selections, location, selected) {
    if (!selected)
        return selections.filter((item) => item.location_id !== location.id);
    const current = selections.find((item) => item.location_id === location.id);
    const defaults = location.options
        .filter((option) => option.is_default)
        .map((option) => option.location_option_id);
    if (current) {
        return selections.map((item) => item.location_id === location.id
            ? { ...item, option_ids: [...new Set([...item.option_ids, ...defaults])] }
            : item);
    }
    return [...selections, { location_id: location.id, option_ids: [...new Set(defaults)] }];
}
export function setLocationOptionSelected(selections, location, optionId, selected) {
    const current = selections.find((item) => item.location_id === location.id);
    if (!current)
        return selections;
    const option = location.options.find((item) => item.location_option_id === optionId);
    if (!option || (option.is_default && !selected))
        return selections;
    const optionIds = selected
        ? [...new Set([...current.option_ids, optionId])]
        : current.option_ids.filter((id) => id !== optionId);
    return selections.map((item) => item.location_id === location.id ? { ...item, option_ids: optionIds } : item);
}
const featureLines = (value) => value
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean);
export function buildLandingTariffCardInput(draft) {
    const translations = {
        en: { title: '', features: [], badge: null },
    };
    for (const locale of ['en', 'ru', 'hy', 'tr']) {
        const value = draft.translations[locale];
        if (!value)
            continue;
        translations[locale] = {
            title: value.title.trim(),
            features: featureLines(value.features),
            badge: value.badge.trim() || null,
        };
    }
    return {
        is_active: draft.isActive,
        sort_order: Number(draft.sortOrder),
        device_number: Number(draft.deviceNumber),
        locations: normalizedSelections(draft.locations),
        translations,
    };
}
export function validateLandingTariffCardDraft(draft, range) {
    const problems = [];
    const order = Number(draft.sortOrder);
    const devices = Number(draft.deviceNumber);
    if (!draft.sortOrder.trim() || !Number.isInteger(order) || order < 0) {
        problems.push('Порядок должен быть целым неотрицательным числом.');
    }
    if (!draft.deviceNumber.trim() || !Number.isInteger(devices)) {
        problems.push('Укажите целое количество устройств.');
    }
    else if (range && (devices < range.min || devices > range.max)) {
        problems.push(`Количество устройств должно быть от ${range.min} до ${range.max}.`);
    }
    if (draft.locations.length === 0) {
        problems.push('Выберите хотя бы одну локацию.');
    }
    else if (draft.locations.some((selection) => selection.option_ids.length === 0)) {
        problems.push('Для каждой локации выберите хотя бы одну опцию.');
    }
    for (const locale of ['en', 'ru', 'hy', 'tr']) {
        const translation = draft.translations[locale];
        if (!translation)
            continue;
        const title = translation.title.trim();
        if (!title) {
            problems.push(locale === 'en'
                ? 'Заполните название на английском.'
                : `Заполните название ${locale.toUpperCase()} или удалите этот перевод.`);
        }
        if (title.length > 200)
            problems.push(`Название ${locale.toUpperCase()} длиннее 200 символов.`);
        const features = featureLines(translation.features);
        if (features.length > 30)
            problems.push(`В переводе ${locale.toUpperCase()} больше 30 пунктов.`);
        if (features.some((feature) => feature.length > 500)) {
            problems.push(`Пункт описания ${locale.toUpperCase()} длиннее 500 символов.`);
        }
        if (translation.badge.trim().length > 100) {
            problems.push(`Плашка ${locale.toUpperCase()} длиннее 100 символов.`);
        }
    }
    return problems;
}
